/**
 * Created by oronm on 15/09/2016.
 */

const linkTag = data => {
  return {
    name: data.name,
    path: data.path
  };
};

module.exports = linkTag;



// WEBPACK FOOTER //
// ./Modules/LinkTag.js